<template>
  <div class="call-handler">
    <div class="call-handler-contents">
      <h6>{{ call_state }}</h6>
      <h5>
        {{ caller_name }} <span class="border-box">{{ queue_name }}</span>
      </h5>
      <h6>{{ caller_number }}</h6>
      <div class="call-handle-buttons-container">
        <b-button
          @click="addNotes()"
          size="sm"
          variant="outline-secondary"
          style="width: 140px;"
        >
          <font-awesome-icon icon="sticky-note" size="sm" />
          <span> Add Notes</span>
        </b-button>
        <b-button
          @click="OnClearContacts()"
          size="sm"
          variant="outline-secondary"
          style="margin-left: 6px;width: 140px;"
        >
          <font-awesome-icon icon="window-close" size="sm" />
          <span> Close Contact</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
import { onClearContacts } from "../../../lib/CallActions";

export default {
  name: "AfterCallWork",
  data() {
    return {};
  },
  methods: {
    OnClearContacts() {
      onClearContacts();
    },
    cancelEditor() {
      this.$store.dispatch("ticket/toggleEditor", false);
      this.$store.dispatch("ticket/toggleNoteButton", false);
    },
    addNotes() {
      this.$store.dispatch("call/updateNotesEditor", true);
    },
  },
  computed: {
    ...mapGetters(["call_state", "caller_name", "queue_name", "caller_number"]),
  },
};
</script>

<style scoped>
.border-box {
  border: 1px solid grey;
  border-radius: 0.77rem;
  color: rgb(0, 0, 0);
  font-size: 0.75rem;
  padding: 0 0.35rem;
  background-color: #aaacad;
}
.call-handler {
  display: table;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.call-handler-contents {
  display: table-cell;
  margin: 0;
}
.call-handle-buttons-container {
  margin-bottom: 0.5rem;
}
</style>
